module.exports = __webpack_public_path__ + "media/images/front/materiales_mid-e73da9cdbd1b3736fe95b3da03dc7274.webp";